import RichTextFieldStrapi, {
  RichTextFieldStrapiProps,
} from '@/components/atoms/RichTextField/RichTextFieldStrapi';
import { cn } from '@/lib/utils';

type Props = {
  description: RichTextFieldStrapiProps;
  isCardFullWidth?: boolean;
};

export default function ProductCardDescription({
  description,
  isCardFullWidth = false,
}: Props) {
  return (
    <div data-tracker-component='description' className='mb-6'>
      <RichTextFieldStrapi
        block={description}
        classNames={{
          paragraph: cn(
            'text-body-m text-gray-500 dark:text-gray-dark-500',
            isCardFullWidth && 'max-w-md',
            !isCardFullWidth && 'h-15 line-clamp-3'
          ),
        }}
      />
    </div>
  );
}
